function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 508 508",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 91.7,
    style: {
      fill: "#FFC10D"
    },
    width: 451,
    height: 28.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.2,
    y: 267.1,
    style: {
      fill: "#56ACE0"
    },
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M493.6,63.5h-254V14.1c0-7.8-6.3-14.1-14.1-14.1h-165c-7.8,0-14.1,6.3-14.1,14.1v49.4h-32 c-7.8,0-14.1,6.3-14.1,14.1V134c0,7.8,6.3,14.1,14.1,14.1h32v345.2c0,0.1,0,0.1,0,0.2c-0.5,8.3,5.1,14.4,14.1,14.5 c1.4,0,163.6,0,165,0c8.4,0,13.9-6.1,14.1-14.5c0-0.1,0-0.1,0-0.2V148h136.5v90.9h-24c-7.8,0-14.1,6.3-14.1,14.1v76.2 c0,7.8,6.3,14.1,14.1,14.1h24v6.1c-25.9,6.3-45.1,29.7-45.1,57.5c0,32.7,26.6,59.2,59.2,59.2c32.7,0,59.2-26.6,59.2-59.2 c0-7.8-6.3-14.1-14.1-14.1c-7.8,0-14.1,6.3-14.1,14.1c0,17.1-13.9,31.1-31,31.1s-31.1-13.9-31.1-31.1s13.9-31,31.1-31 c7.8,0,14.1-6.3,14.1-14.1v-18.5h24c7.8,0,14.1-6.3,14.1-14.1V253c0-7.8-6.3-14.1-14.1-14.1h-24V148h89.3c7.8,0,14.1-6.3,14.1-14.1 V77.6C507.7,69.8,501.4,63.5,493.6,63.5z M74.6,28.2h136.8v35.3H74.6V28.2z M97.4,479.2l45.6-41.8l45.6,41.8H97.4z M74.6,461.9 v-87.2l47.5,43.6L74.6,461.9z M211.4,461.9l-47.5-43.6l47.5-43.6V461.9z M211.4,336.4L143,399.1l-68.4-62.7v-18l68.4-62.7l68.4,62.7 V336.4z M74.6,280.1v-87.2l47.5,43.6L74.6,280.1z M211.4,280.1l-47.5-43.6l47.5-43.6V280.1z M211.4,154.7L143,217.4l-68.4-62.7V148 h136.8V154.7z M414.2,267.1v48h-48v-48H414.2z M479.5,119.8h-451V91.7h451V119.8z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuild);
export default __webpack_public_path__ + "static/media/Build.137cf8ac.svg";
export { ForwardRef as ReactComponent };